import { render, staticRenderFns } from "./APP_bannerList.vue?vue&type=template&id=09f65170&scoped=true&"
import script from "./APP_bannerList.vue?vue&type=script&lang=js&"
export * from "./APP_bannerList.vue?vue&type=script&lang=js&"
import style0 from "./APP_bannerList.vue?vue&type=style&index=0&id=09f65170&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f65170",
  null
  
)

export default component.exports